import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import api from "../api/axios";

function AssignMenu() {
  const [roles, setRoles] = useState([]);
  const [menus, setMenus] = useState([]);

  const [roleId, setRoleId] = useState("");
  const [selectedMenus, setSelectedMenus] = useState([]);
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    loadRoles();
    loadMenus();
  }, []);

  const loadRoles = async () => {
    const res = await api.get("/Login/GetUser");
    setRoles(res.data);
  };

  const loadMenus = async () => {
    const res = await api.get("/Menu/GetMenu");
    setMenus(res.data);
  };

  const handleMenu = (id) => {
    if (selectedMenus.includes(id)) {
      setSelectedMenus(selectedMenus.filter((x) => x !== id));
    } else {
      setSelectedMenus([...selectedMenus, id]);
    }
  };

  const save = async (e) => {
    e.preventDefault();

    const data = {
      roleId,
      menuIds: selectedMenus,
      isActive,
    };

    try {
      const res = await api.post("/Menu/AssignMenu", data);

      Swal.fire("Success", res.data.message, "success");

      setRoleId("");
      setSelectedMenus([]);
      setIsActive(true);
    } catch (err) {
      Swal.fire("Error", "Something went wrong", "error");
    }
  };

  //const parents = menus.filter((x) => x.parentId == null);
const parents = menus.filter(
  (x) => x.parentId == null || Number(x.parentId) === 0
);
  return (
    <div className="card shadow">

      <div className="card-header bg-primary text-white">
        <h4>Assign Menu</h4>
      </div>

      <div className="card-body">

        <form onSubmit={save}>

          <div className="mb-3">

            <label>Select Role</label>

            <select
              className="form-select"
              value={roleId}
              onChange={(e) => setRoleId(e.target.value)}
            >
              <option value="">Select Role</option>

              {roles.map((r) => (
                <option key={r.roleId} value={r.roleId}>
                  {r.roleName}
                </option>
              ))}

            </select>

          </div>

          <hr />

          <h5>Menus</h5>

          {parents.map((parent) => (

            <div key={parent.menuId} className="mb-3">

              <div className="form-check">

                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={selectedMenus.includes(parent.menuId)}
                  onChange={() => handleMenu(parent.menuId)}
                />

                <label className="form-check-label fw-bold">
                  {parent.menuName}
                </label>

              </div>

              <div className="ms-4 mt-2">

                {menus
                  .filter((x) => x.parentId === parent.menuId)
                  .map((child) => (

                    <div className="form-check" key={child.menuId}>

                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={selectedMenus.includes(child.menuId)}
                        onChange={() => handleMenu(child.menuId)}
                      />

                      <label className="form-check-label">
                        {child.menuName}
                      </label>

                    </div>

                  ))}

              </div>

            </div>

          ))}

          <div className="form-check mb-3">

            <input
              type="checkbox"
              className="form-check-input"
              checked={isActive}
              onChange={(e) => setIsActive(e.target.checked)}
            />

            <label className="form-check-label">
              Active
            </label>

          </div>

          <button className="btn btn-success">
            Save
          </button>

        </form>

      </div>

    </div>
  );
}

export default AssignMenu;